import {
  AbbrApi,
  ArrowsRotateLeft,
  BookOpen,
  ChartAreaStackedNormalized,
  FolderArrowDown,
  LayoutList,
  Person,
} from "@gravity-ui/icons";
import { RoutesPaths } from "src/routes/RoutesPaths";

import { MenuItem } from "./dto/MenuItem.ts";

export const menuItems: MenuItem[] = [
  {
    id: "profile",
    title: "Профиль",
    icon: Person,
    path: RoutesPaths.LK.PROFILE.BASE_PATH,
    current: (path) => path.includes(RoutesPaths.LK.PROFILE.BASE_PATH),
    type: "regular",
  },
  {
    id: "subscribe",
    title: "Подписки",
    icon: ChartAreaStackedNormalized,
    path: RoutesPaths.LK.SUBSCRIBE,
    current: (path) => path.includes(RoutesPaths.LK.SUBSCRIBE),
    type: "regular",
  },
  {
    id: "profile_divider",
    title: "",
    type: "divider",
  },
  {
    id: "goods",
    title: "Товары",
    icon: LayoutList,
    path: RoutesPaths.LK.GOODS,
    current: (path) => path.includes(RoutesPaths.LK.GOODS),
    type: "regular",
  },
  // {
  //   id: "scanner",
  //   title: "Сканер",
  //   icon: QrCode,
  //   path: RoutesPaths.LK.SCANNER,
  //   current: (path) => path.includes(RoutesPaths.LK.SCANNER),
  //   type: "regular",
  // },
  {
    id: "export",
    title: "Выгрузка",
    icon: FolderArrowDown,
    path: RoutesPaths.LK.EXPORT,
    current: (path) => path.includes(RoutesPaths.LK.EXPORT),
    type: "regular",
  },
  {
    id: "converter",
    title: "Конвертер ссылок",
    icon: ArrowsRotateLeft,
    path: RoutesPaths.LK.CONVERTER,
    current: (path) => path.includes(RoutesPaths.LK.CONVERTER),
    type: "regular",
  },
  {
    id: "api-docs",
    title: "API документация",
    icon: AbbrApi,
    path: RoutesPaths.LK.API_DOCS,
    current: (path) => path.includes(RoutesPaths.LK.API_DOCS),
    type: "regular",
  },
  {
    id: "docs",
    title: "База знаний",
    icon: BookOpen,
    path: RoutesPaths.LK.API_KNOWLEDGE_BASE,
    current: (path) => path.includes(RoutesPaths.LK.API_KNOWLEDGE_BASE),
    type: "regular",
  },
];
